import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Adobe Express - file.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              PERMITIME <span className="purple"> PRESENTARME </span>
            </h1>
            <p className="home-about-body">
              Más de 3 años de experiencia desarrollando en C#, conectando todo
              sin romper nada… o casi.
              <br />
              <br />
              También programo a diario en lenguajes como
              <i>
                <b className="purple"> Javascript y Java. </b>
              </i>
              <br />
              <br />
              Mi principal interés está en el desarrollo de &nbsp;
              <i>
                <b className="purple">Nuevas Tecnologias del entorno .NET, </b>{" "}
                sí como en áreas relacionadas con
                <b className="purple"> Devops.</b>
              </i>
              <br />
              <br />
              Cuando tengo tiempo, me gusta seguir aprendiendo sobre
              <i>
                <b className="purple"> Librerias y Frameworks Modernos</b>
              </i>
              &nbsp; como
              <i>
                <b className="purple"> React.js y Next.js</b>
              </i>
            </p>
          </Col>
          <Col md={3} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>REDES SOCIALES</h1>
            <p>
              <span className="purple">Conectemos! </span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Dekuarg"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="www.linkedin.com/in/fede-kaprielian"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/fede_kapre"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
